module.exports = __webpack_public_path__ + "img/arrow4.44acfeff.svg";